<div class="loading-spinner loading" *ngIf="!tabs; else tabsTemplate">
  <div class="cc-icon cc-icon-spinner-3x"></div>
</div>

<ng-template #tabsTemplate>
  <div class="tab-arrow tab-arrow-left" [class.disabled]="!list.canScrollStart">
    <button
      type="button"
      class="btn tab-action-button d-flex justify-content-center align-items-center animate-fade-in"
      *ngIf="list.isOverflow"
      (click)="list.scroll(-1)"
    >
      <i class="cc-icon cc-icon-arrow-left"></i>
    </button>
  </div>
  <div
    class="tab-wrapper d-flex"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="drop($event)"
    #tabWrapper
    ccScrollTab
    #list="ccScrollTab"
  >
    <cc-templates-list-tab-filter-item
      [tab]="allTab"
      (selectTab)="selectAll()"
      [canEdit]="false"
      class="all-tab"
      [selected]="allTab.selected"
    ></cc-templates-list-tab-filter-item>
    <cc-templates-list-tab-filter-item
      *ngFor="let tab of tabs"
      [tab]="tab"
      (selectTab)="selectTab($event)"
      (addTab)="addTab($event)"
      (editTab)="editTab($event)"
      (deleteTab)="deleteTab($event)"
      (enableAddButton)="enableAddButton($event)"
      (removeNewTab)="removeNewTab($event)"
      (toggleDrag)="toggleDrag($event)"
      (cdkDragStarted)="dragStarted($event)"
      cdkDrag
      [selected]="tab.selected"
      [sortValue]="tab.sortValue"
      [canEdit]="canEdit"
      [cdkDragDisabled]="dragDisabled(tab)"
      [tabsNames]="tabsNames"
      [id]="'template-tabs-' + tab.id"
      #tabItem
    ></cc-templates-list-tab-filter-item>
  </div>
  <div class="tab-arrow tab-arrow-right" [class.disabled]="!list.canScrollEnd" [class.right]="!canEdit">
    <button
      type="button"
      class="btn tab-action-button d-flex justify-content-center align-items-center btn-next animate-fade-in"
      *ngIf="list.isOverflow"
      (click)="list.scroll(1)"
    >
      <i class="cc-icon cc-icon-arrow-right"></i>
    </button>
  </div>
  <div class="tabs-actions-right" *ngIf="canEdit">
    <button
      type="button"
      class="btn add-tab tab-action-button d-flex justify-content-center align-items-center"
      [disabled]="disabledAddButton"
      (click)="newTab()"
    >
      <i class="cc-icon cc-icon-plus"></i>
    </button>
  </div>
</ng-template>
